export enum ShippingMemberType {
    DISTRIBUTOR = 4,
    RETAIL = 6
}



// WEBPACK FOOTER //
// ./src/app/customerservice/enums/shipping-member-type.enum.ts